var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturedicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.66797,
    y: 2.01074,
    width: 24.0635,
    height: 24.0635,
    rx: 12.0318,
    fill: "#F3F6F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8112_41523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.68555 15.2952L13.5194 17.7121C13.5852 17.745 13.6181 17.7614 13.6526 17.7679C13.6831 17.7736 13.7145 17.7736 13.745 17.7679C13.7795 17.7614 13.8124 17.745 13.8781 17.7121L18.712 15.2952M8.68555 12.7886L13.5194 10.3716C13.5852 10.3387 13.6181 10.3223 13.6526 10.3158C13.6831 10.3101 13.7145 10.3101 13.745 10.3158C13.7795 10.3223 13.8124 10.3387 13.8781 10.3716L18.712 12.7886L13.8781 15.2055C13.8124 15.2384 13.7795 15.2548 13.745 15.2613C13.7145 15.267 13.6831 15.267 13.6526 15.2613C13.6181 15.2548 13.5852 15.2384 13.5194 15.2055L8.68555 12.7886Z",
    stroke: "#445FD2",
    strokeWidth: 1.00265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.66797,
    y: 2.01074,
    width: 24.0635,
    height: 24.0635,
    rx: 12.0318,
    stroke: "#F3F6F9",
    strokeWidth: 3.00794
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8112_41523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.0318,
    height: 12.0318,
    fill: "white",
    transform: "translate(7.68164 8.02734)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedicon);
export default __webpack_public_path__ + "static/media/Featuredicon.9489c14a97f6a1a37b90e8ef9123e532.svg";
export { ForwardRef as ReactComponent };